import { activateTracking } from './trackers';
console.log('reached');
document.addEventListener('DOMContentLoaded', function () {
    // function body
    activateTracking();
});
